import { Container, styled } from "@mui/material";

const PageContainer = styled(Container)(() => ({
  flexGrow: 1,
  display: "flex",
  padding: 20,
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  margin: "auto",
}));

export default PageContainer;
